// Draws text + sticker overlay items onto a transparent 2D canvas.
// Coordinates are fractions of the frame (0..1). Time is project-raw seconds.

function roundRect(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
}

export function drawOverlay(ctx, W, H, items, t, selectedId) {
    ctx.clearRect(0, 0, W, H);
    if (!items || !items.length) return;
    for (const it of items) {
        if (t < it.start || t > it.end) continue;
        const local = t - it.start;
        const dur = Math.max(0.05, it.end - it.start);
        ctx.save();

        let alpha = 1;
        let scale = 1;
        let dx = 0;
        if (it.anim === "fade") {
            alpha = Math.min(1, local / 0.4) * Math.min(1, Math.max(0, dur - local) / 0.4);
        } else if (it.anim === "pop") {
            scale = 0.55 + 0.45 * Math.min(1, local / 0.25);
            alpha = Math.min(1, local / 0.15);
        } else if (it.anim === "slide") {
            dx = (1 - Math.min(1, local / 0.45)) * 0.22 * W;
            alpha = Math.min(1, local / 0.2);
        }
        ctx.globalAlpha = Math.max(0, Math.min(1, alpha));
        ctx.translate(it.x * W + dx, it.y * H);
        ctx.scale(scale, scale);

        if (it.type === "sticker") {
            const fs = (it.size / 100) * H;
            ctx.font = `${fs}px serif`;
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText(it.content, 0, 0);
        } else {
            const fs = (it.size / 100) * H;
            ctx.font = `${it.italic ? "italic " : ""}${it.bold ? "700" : "400"} ${fs}px ${it.font || "Outfit"}, sans-serif`;
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            const lines = String(it.content || "").split("\n");
            const lineH = fs * 1.15;
            const totalH = lineH * lines.length;

            if (it.bg) {
                let wMax = 0;
                for (const ln of lines) wMax = Math.max(wMax, ctx.measureText(ln).width);
                ctx.fillStyle = "rgba(11,12,16,0.75)";
                roundRect(ctx, -wMax / 2 - fs * 0.3, -totalH / 2 - fs * 0.22, wMax + fs * 0.6, totalH + fs * 0.44, fs * 0.18);
                ctx.fill();
            }
            if (it.shadow) {
                ctx.shadowColor = "rgba(0,0,0,0.75)";
                ctx.shadowBlur = fs * 0.14;
                ctx.shadowOffsetY = fs * 0.04;
            }
            lines.forEach((ln, i) => {
                const yy = -totalH / 2 + lineH * i + lineH / 2;
                if (it.outline) {
                    ctx.lineWidth = Math.max(2, fs * 0.09);
                    ctx.lineJoin = "round";
                    ctx.strokeStyle = "#000";
                    ctx.strokeText(ln, 0, yy);
                }
                ctx.fillStyle = it.color || "#ffffff";
                ctx.fillText(ln, 0, yy);
            });
        }

        if (selectedId === it.id) {
            const w = it.type === "sticker" ? (it.size / 100) * H : (it.size / 100) * H * 4;
            ctx.globalAlpha = 0.9;
            ctx.strokeStyle = "#FF9F1C";
            ctx.lineWidth = 2;
            ctx.setLineDash([8, 6]);
            ctx.strokeRect(-w / 2, (-it.size / 100) * H * 0.7, w, (it.size / 100) * H * 1.4);
        }
        ctx.restore();
    }
}

export function hitTestOverlay(items, t, px, py, W, H) {
    if (!items) return null;
    for (let i = items.length - 1; i >= 0; i--) {
        const it = items[i];
        if (t < it.start || t > it.end) continue;
        const halfW = (it.type === "sticker" ? (it.size / 100) * H : (it.size / 100) * H * 2.2) / 2;
        const halfH = ((it.size / 100) * H * 1.4) / 2;
        if (Math.abs(px - it.x * W) <= halfW && Math.abs(py - it.y * H) <= halfH) return it.id;
    }
    return null;
}
